import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const FresherjobsGhazi = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title>{`Fresher Jobs in Ghaziabad  | Latest Job Openings ${currentYear}`}</title>
        <meta
          name="description"
          content="Find the latest fresher jobs in Ghaziabad  NCR for graduates and students. Apply for IT, Marketing, Finance, HR, and Sales jobs in top companies hiring freshers in Ghaziabad ."
        />
        <meta
          name="keywords"
          content="fresher jobs in Ghaziabad , fresher jobs in Ghaziabad  NCR, jobs for freshers in Ghaziabad , IT fresher jobs Ghaziabad , marketing fresher jobs Ghaziabad , graduate jobs Ghaziabad , entry-level jobs Ghaziabad "
        />
        <meta name="author" content="JobsInDelhi NCR" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://jobsinGhaziabadncr.in/fresher-jobs-in-ghaziabad" />
      </Helmet>

      <Navbar />

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Fresher Jobs in Ghaziabad  – Latest Job Openings {currentYear}
        </h1>

        <p className="text-gray-600 mb-6">
          Looking for the latest <strong>fresher jobs in Ghaziabad </strong>? Explore
          thousands of opportunities in IT, Marketing, Finance, Education,
          Healthcare, and more. Whether you’re a graduate or a student, find your
          first job in Ghaziabad  NCR today and kickstart your career.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring Freshers in Ghaziabad 
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Infosys</li>
          <li>Wipro</li>
          <li>Tech Mahindra</li>
          <li>HCL</li>
          <li>Accenture</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Job Categories Available
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Software Development Jobs in Ghaziabad </li>
          <li>Marketing Jobs in Ghaziabad </li>
          <li>Finance Jobs in Ghaziabad </li>
          <li>Sales Jobs in Ghaziabad </li>
          <li>Full-time Jobs in Ghaziabad </li>
          <li>Web Development Jobs in Ghaziabad </li>
          <li>Digital Marketing Jobs in Ghaziabad </li>
          <li>Telecalling Jobs in Ghaziabad </li>
          <li>IT Jobs in Ghaziabad </li>
          <li>Technical Support Jobs in Ghaziabad </li>
          <li>App Development Jobs in Ghaziabad </li>
          <li>HR Jobs in Ghaziabad </li>
          <li>Fresher Jobs in Ghaziabad </li>
          <li>Frontend Developer Jobs in Ghaziabad </li>
          <li>Backend Developer Jobs in Ghaziabad </li>
          <li>Full Stack Developer Jobs in Ghaziabad </li>
        </ul>

        <p className="text-gray-600">
          Start your career with <strong>jobsindelhincr.in</strong> – your trusted
          platform to find verified <strong>fresher job openings</strong> in Ghaziabad.
          No registration required – apply directly to companies hiring today!
        </p>
      </div>

      <Footer />
    </>
  );
};

export default FresherjobsGhazi;
